"use strict";
const PI_2 = Math.PI * 2;
const RAD_TO_DEG = 180 / Math.PI;
const DEG_TO_RAD = Math.PI / 180;

export { DEG_TO_RAD, PI_2, RAD_TO_DEG };
//# sourceMappingURL=const.mjs.map
